import React from "react";
import Footer from "../footer/index2";
import { Container, MainContainer } from "./styles";
import { useTranslation } from "react-i18next";

const Imprint = () => {

  const { t } = useTranslation();

  return (
    <div>
      <MainContainer>
        <h1>{t("imprint")}</h1>
        <Container>
          <h2>{t("Information according to § 5 TMG:")}</h2>
          <p>SH Digits - Sascha Hoffmann <br/> Nußbaumstraße 8 <br/>85757 Karlsfeld</p>
          <p>
            {t("email")}: <a style={{color: '#3fc4fd', textDecoration:'none'}} href="mailto:info@whistleblowing24.com">info@whistleblowing24.com</a> 
            <br/>
            {t("website")}: <a style={{color: '#3fc4fd', textDecoration:'none'}} href="https://whistleblowing24.com">www.whistleblowing24.com</a>
          </p>
          <p>{t("owner")}: Sascha Hoffmann</p>
          <p>{t("VAT identification number")}: DE274770876</p>
          <p style={{fontWeight: 700, fontSize:'18px'}}>
            {t("Liability for content")}
          </p>
          <p>
            {t("imprintLiabilityContent")}
          </p>
          <p style={{fontWeight: 700, fontSize:'18px'}}>
            {t("Liability for links")}
          </p>
          <p>{t("imprintLiabilityLinks")}</p>
          <p style={{fontWeight: 700, fontSize:'18px'}}>
            {t("copyright")}
          </p>
          <p>
            {t("imprintCopyrightContent")}
          </p>
          <p style={{fontWeight: 700, fontSize:'18px'}}>
            {t("Responsible within the meaning of Section 55 Paragraph 2 RStV.")}
          </p>
          <p>Sascha Hoffmann <br/> Nußbaumstraße 8 <br/>85757 Karlsfeld
            <br/>
            {t("email")}: <a style={{color: '#3fc4fd', textDecoration:'none'}} href="mailto:info@whistleblowing24.com">info@whistleblowing24.com</a>
          </p>
        </Container>
      </MainContainer>
      {/* <Footer></Footer> */}
    </div>
  );
};

export default Imprint;
